export default __webpack_public_path__ + "static/media/fromTo.f35444b3.svg";